import { NavLink } from 'react-router-dom';
import { ScrollArea } from 'components/ui/scroll-area';
import { cn } from 'lib/utils';
import { docsNavSections } from '../docs-nav-data';

export function DocsSidebar() {
  return (
    <aside className="hidden w-64 shrink-0 border-r border-border md:block">
      <ScrollArea className="h-full px-4 py-6">
        <nav className="flex flex-col gap-6">
          {docsNavSections.map((section) => (
            <div key={section.title}>
              <p className="mb-2 px-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                {section.title}
              </p>
              <ul className="flex flex-col gap-0.5">
                {section.links.map((link) => (
                  <li key={link.slug}>
                    <NavLink
                      to={`/docs/${link.slug}`}
                      className={({ isActive }) =>
                        cn(
                          'block rounded-md px-2 py-1.5 text-sm transition-colors',
                          isActive
                            ? 'bg-accent font-medium text-accent-foreground'
                            : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
                        )
                      }
                    >
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </ScrollArea>
    </aside>
  );
}
